import { createFileRoute } from "@tanstack/react-router";
import DiagnosticadorLocales from "@/pages/DiagnosticadorLocales";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/diagnostico-locales-comerciales")({
  head: () => pageHead("locationAnalysis", "es"),
  component: DiagnosticadorLocales,
});
